<template>
  <Notification :item>
    <template #logo>
      <FontAwesomeIcon
        :icon="['fak', 'list']"
        :style="{ height: '16px', width: '16px', color: 'currentColor' }"
        class="text-info-accent"
      />
    </template>
    <template #message> New Member Joined</template>
    <template #description>
      <div>
        {{ notificationDescription }}
      </div>
    </template>
    <template v-if="report" #action>
      <BittsButton
        text="View List"
        variant="outline"
        size="x-small"
        @click="handleViewList"
      />
    </template>
  </Notification>
</template>
<script setup lang="ts">
import { BittsButton } from '@crossbeam/bitts';

import { storeToRefs } from 'pinia';
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';

import Notification from '@/components/notifications/Notification.vue';

import { useNotificationsStore, useReportsStore } from '@/stores';
import { Notification as NotificationType } from '@/types/notifications';

const { item } = defineProps<{ item: NotificationType }>();

const emit = defineEmits<(e: 'action-clicked', action: string) => void>();

const router = useRouter();
const notificationsStore = useNotificationsStore();
const reportsStore = useReportsStore();

const { reports } = storeToRefs(reportsStore);
const report = computed(() =>
  reports.value.find((r) => r.id === item.data?.report_id),
);

onMounted(async () => {
  if (!report.value) await reportsStore.refreshReportsStore();
});
const notificationDescription = computed(() => {
  const collaboratorName = item.data?.added_user_names || 'A new collaborator';
  const reportName = item.data?.report_name || 'a List';
  return `${collaboratorName} joined ${reportName}`;
});

async function handleViewList() {
  if (!report.value) return;
  emit('action-clicked', 'View List');
  await notificationsStore.markRead({ id: item.id, isRead: true });
  await router.push({
    name: 'edit_report',
    params: { report_id: report.value.id },
  });
}
</script>
